module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "/OfflinePay",
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/MyBill"
    }
  }, [_vm._v("新生缴费")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/OfflinePay"
    }
  }, [_vm._v("线下审核")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), (_vm.curStudent.studentName) ? _c('el-row', {
    staticClass: "content"
  }, [_c('el-row', {
    staticClass: "content-main"
  }, [_c('el-form', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "model": _vm.curStudent,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.curStudent.studentName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "身份证号"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.curStudent.uid))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "专业"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.curStudent.majorMatr))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学年"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.curStudent.enrollmentYear))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "content"
  }, [_c('el-row', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("申请记录")]), _vm._v(" "), (_vm.applyList.length === 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "20px",
      "color": "#999"
    }
  }, [_vm._v("\n        暂无申请记录\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.applyList), function(item) {
    return _c('div', {
      key: item.orderNo,
      staticClass: "apply-item"
    }, [_c('el-row', {
      staticClass: "apply-row"
    }, [_c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_c('span', {
      staticClass: "apply-label"
    }, [_vm._v("申请单号：")]), _vm._v(" "), _c('span', {
      staticClass: "apply-value"
    }, [_vm._v(_vm._s(item.orderNo))])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        "span": 8
      }
    }, [_c('van-tag', {
      attrs: {
        "type": _vm.getStatusTagType(item.dataStatus)
      }
    }, [_vm._v(_vm._s(_vm.formatStatus(item.dataStatus)))])], 1)], 1), _vm._v(" "), _c('el-row', {
      staticClass: "apply-row"
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "apply-label"
    }, [_vm._v("申请时间：")]), _vm._v(" "), _c('span', {
      staticClass: "apply-value apply-time"
    }, [_vm._v(_vm._s(_vm.formatTime(item.dataTime)))])])], 1), _vm._v(" "), (item.userName) ? _c('el-row', {
      staticClass: "apply-row"
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "apply-label"
    }, [_vm._v("申请人：")]), _vm._v(" "), _c('span', {
      staticClass: "apply-value"
    }, [_vm._v(_vm._s(item.userName))])])], 1) : _vm._e(), _vm._v(" "), (item.dataStatus === '02' && item.remark) ? _c('el-row', {
      staticClass: "apply-row"
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "apply-label"
    }, [_vm._v("拒绝原因：")]), _vm._v(" "), _c('span', {
      staticClass: "apply-value reject-reason"
    }, [_vm._v(_vm._s(item.remark))])])], 1) : _vm._e()], 1)
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b8ca8fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/XiFan/NewStudent/OfflinePay.vue
// module id = 1278
// module chunks = 1